import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=3f95b6be&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=3f95b6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95b6be",
  null
  
)

export default component.exports